import { isFeatureNavigable, normalizeFeatures } from "./registry";

// These groups only filter records supplied by the server; they add no services.
export const TODAY_INTENTS = [
  { id: "all", label: "Tout voir" },
  { id: "find", label: "Chercher" },
  { id: "offer", label: "Proposer" },
  { id: "organize", label: "Organiser" },
  { id: "connect", label: "Échanger" },
];

const INTENT_FEATURES = {
  find: ["today-mutual-aid", "today-buy", "today-employment", "today-services", "today-travel", "today-real-estate", "today-auctions", "today-flash-sales", "today-animals", "today-babysitting", "today-global-search", "today-live-map", "deterministic-filter-matching"],
  offer: ["today-mutual-aid", "today-sell", "today-employment", "today-services", "today-donations", "today-crowdfunding", "today-studio"],
  organize: ["today-mutual-aid", "today-agenda", "today-outings", "today-sport", "today-travel", "today-babysitting", "today-guided-journeys", "notification-center", "services-quotes-followup", "employment-internal-application"],
  connect: ["today-mutual-aid", "today-forum", "today-friends", "today-chat", "today-community", "today-outings", "today-daily-circles", "marketplace-contact-followup"],
};

export function matchesTodayIntent(feature, intent) {
  return intent === "all" || Boolean(INTENT_FEATURES[intent]?.includes(feature.featureKey));
}

// Both Today surfaces use the server catalogue, never a second list of services.
export function getTodayCatalog(features) {
  const catalog = { available: [], readOnly: [], privateBeta: [], upcoming: [] };
  normalizeFeatures(features)
    .map((feature) => feature.featureKey === "today-crowdfunding" ? { ...feature, title: "Crowdfunding" } : feature)
    .filter((feature) => feature.section === "today" && feature.isVisible !== false && !feature.isProspective && feature.functionalStatus !== "PROSPECTIVE")
    .forEach((feature) => {
      if (["ACTIVE", "BETA"].includes(feature.functionalStatus)) catalog.available.push(feature);
      else if (feature.functionalStatus === "READ_ONLY") catalog.readOnly.push(feature);
      else if (feature.functionalStatus === "PRIVATE_BETA") catalog.privateBeta.push(feature);
      else catalog.upcoming.push(feature);
    });
  const home = catalog.available.filter((feature) => feature.route && isFeatureNavigable(feature));
  // Keep the existing campaign card in the first row, without duplicating it.
  const crowdfundingIndex = home.findIndex((feature) => feature.featureKey === "today-crowdfunding");
  if (crowdfundingIndex > 1) home.splice(1, 0, home.splice(crowdfundingIndex, 1)[0]);
  return { ...catalog, home };
}
